import React from 'react';

import { getMode } from '@ionic/core';
import { IonHeader, IonToolbar, IonButtons, IonButton, IonTitle, IonContent, IonList, IonListHeader, IonItem, IonLabel, IonCheckbox, IonFooter, IonIcon } from '@ionic/react';
import { logoAngular, call, document, logoIonic, hammer, restaurant, cog, colorPalette, construct, compass } from 'ionicons/icons';

import './SessionListFilter.css'

import { connect } from '../data/connect';
import { updateFilteredTracks } from '../data/sessions/sessions.actions';

interface OwnProps {
  onDismissModal: () => void;
}

interface StateProps {
  allTracks: string[],
  filteredTracks: string[]
}

interface DispatchProps {
  updateFilteredTracks: typeof updateFilteredTracks;
}

type SessionListFilterProps = OwnProps & StateProps & DispatchProps;

const SessionListFilter: React.FC<SessionListFilterProps> = ({ allTracks, filteredTracks, onDismissModal, updateFilteredTracks }) => {
  const ios = getMode() === 'ios';

  const toggleTrackFilter = (track: string) => {
    if (filteredTracks.indexOf(track) > -1) {
      updateFilteredTracks(filteredTracks.filter(x => x !== track));
    } else {
      updateFilteredTracks([...filteredTracks, track]);
    }
  };

  const handleDeselectAll = () => {
    updateFilteredTracks([]);
  };

  const handleSelectAll = () => {
    updateFilteredTracks([...allTracks]);
  };

  const iconMap: { [key: string]: any } = {
    'Angular': logoAngular,
    'Documentation': document,
    'Food': restaurant,
    'Ionic': logoIonic,
    'Tooling': hammer,
    'Design': colorPalette,
    'Services': cog,
    'Workshop': construct,
    'Navigation': compass,
    'Communication': call
  }

  return (
    <>
      <IonHeader translucent={true} className="session-list-filter">
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={onDismissModal}>Cancelar</IonButton>
          </IonButtons>

          <IonTitle>
            Filtrar Sesiones
          </IonTitle>

          <IonButtons slot="end">
            <IonButton onClick={onDismissModal} strong>Aceptar</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent className="session-list-filter">
        <IonList lines={ ios ? 'inset' : 'full'}>
          <IonListHeader>Tipo sesion</IonListHeader>

          {allTracks.map(track => (
            <IonItem
              key={track}
              className="session-filter-track"
              style={{
                borderLeft: `solid 9px ${track.split('&&&')[1] || 'var(--ion-color-primary)'}`
              }}
            >
              { ios &&
                <IonIcon slot="start" icon={iconMap[track]} color="medium" />
              }
              <IonLabel>{track.split('&&&')[0]}</IonLabel>
              <IonCheckbox
                onClick={() => toggleTrackFilter(track)}
                checked={filteredTracks.indexOf(track) !== -1}
                color="primary"
                value={track.split('&&&')[0]}
              ></IonCheckbox>
            </IonItem>
          ))}
        </IonList>

        {/* Espaciado adicional para asegurar que el contenido no se superponga con el footer */}
        <div className="session-filter-scroll-spacer" aria-hidden="true"></div>
      </IonContent>

      <IonFooter className="session-list-filter-footer ion-no-border">
        <IonToolbar className="session-filter-actions-toolbar">
          <div className="session-filter-footer-actions">
            <IonButton
              expand="block"
              className="session-filter-footer-button"
              onClick={handleDeselectAll}
            >
              Deseleccionar todo
            </IonButton>
            <IonButton
              expand="block"
              className="session-filter-footer-button"
              onClick={handleSelectAll}
            >
              Seleccionar Todo
            </IonButton>
          </div>
        </IonToolbar>
      </IonFooter>
    </>
  );
};

export default connect<OwnProps, StateProps, DispatchProps>({
  mapStateToProps: (state) => ({
    allTracks: state.data.allTracks,
    filteredTracks: state.data.filteredTracks
  }),
  mapDispatchToProps: {
    updateFilteredTracks
  },
  component: SessionListFilter
})
